import { Flex, Table } from 'antd'
import { PAGE_SIZE } from 'src/pages/budget/budgetCategories/const'
import {
  FilterTable,
  getRequestListColumns,
  InfoTag,
} from 'src/pages/budget/budgetRequests/components'
import { filtersChangedBudgetListOwnReject } from 'src/pages/budget/budgetRequests/model'
import { BudgetRequest } from 'src/pages/budget/budgetRequests/types'

type Props = {
  list: BudgetRequest[]
  filterList: BudgetRequest[]
}
export const OwnRejectTable = ({ list, filterList }: Props) => {
  return (
    <Flex vertical gap="middle" style={{ width: '100%' }}>
      <Flex justify="space-between">
        <InfoTag text="Вы можете внести изменения в заявку и отправить на рассмотрение повторно" />
        <FilterTable
          fields={['articleName', 'products', 'searchText']}
          onChange={filtersChangedBudgetListOwnReject}
          list={list}
        />
      </Flex>
      <Table
        dataSource={filterList}
        tableLayout="fixed"
        // rowSelection={{
        //   type: 'checkbox',
        //   selectedRowKeys,
        //   onChange: (keys) => setSelectedRowKeys(keys),
        // }}
        pagination={
          filterList.length > PAGE_SIZE
            ? {
                total: filterList?.length,
                defaultPageSize: PAGE_SIZE,
                showSizeChanger: true,
                position: ['bottomCenter'],
              }
            : false
        }
        columns={getRequestListColumns([
          'id',
          'articleName',
          'itemName',
          'description',
          'amount',
          'productIds',
          'comment',
          'status',
          'actionOwnReject',
        ])}
        rowKey={(record) => record.id}
        rowClassName={(_, index) =>
          `ant_table_row_height ${index % 2 ? 'even-row' : 'odd-row'}`
        }
      />
    </Flex>
  )
}
